import React from 'react'

const Desclaimer = () => {
    return (
        <div className="disclaimer">
            <h4>Disclosure</h4>
            <ul>
                <li>
                    <h4>Accuracy of Information</h4>
                    <p>I hereby declare that all the information provided in this application is correct and true to the best of my knowledge.</p>
                </li>
                <li>
                    <h4>Notification and Refund Obligations</h4>
                    <ul>
                        <li>If I choose to discontinue my education, I will notify Al Kauser at least two (2) months prior to the discontinuation date and provide a legitimate reason for doing so.</li>
                        <li>I agree to refund the total amount paid by Al Kauser as my tuition fee or scholarship within one (1) year of discontinuation.</li>
                        <li>I acknowledge that Al Kauser reserves the right to claim the full amount paid as my tuition fee or scholarship from the educational institution in the event of my discontinuation.</li>
                    </ul>
                </li>
                <li>
                    <h4>Failure to Notify</h4>
                    <ul>
                        <li>If I discontinue my education without informing Al Kauser, I understand that Al Kauser retains the full right to claim the funds paid as tuition fee or scholarship directly from the educational institution.</li>
                        <li>I accept that I am legally bound to refund the total amount paid by Al Kauser as my tuition fee or scholarship.</li>
                    </ul>
                </li>
                <li>
                    <h4>Al Kauser Alumni Commitment</h4>
                    <ul>Upon graduation, I commit to actively supporting Al Kauser Inc. and becoming a member of the Al Kauser Alumni network.</ul>
                </li>
                <li>
                    <h4>Media and Promotional Participation</h4>
                    <ul>I acknowledge that if Al Kauser requests my participation in interviews or social media recordings to promote its activities or highlight achievements, I will make myself available to do so.</ul>
                </li>
            </ul>

        </div>
    )
}

export default Desclaimer